import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from '../assets/images/logo/solar-logo.png'
// import "./LoginPage.css"; // move styles here

const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // validation
  const validate = () => {
    let tempErrors = {};
    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Invalid email address";
    }
    if (!formData.password) {
      tempErrors.password = "Password is required";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading(true);
      const formDataToSend = new FormData();
      formDataToSend.append("email", formData.email);
      formDataToSend.append("password", formData.password);

      const response = await fetch("https://admin.energybazzar.com/api/user/login", {
        method: "POST",
        body: formDataToSend,
      });
      const result = await response.json();

      if (result.success) {
        const loginTime = new Date().getTime();
        localStorage.setItem("loginTime", loginTime);
        localStorage.setItem("UserData", JSON.stringify(result.data));
        navigate("/dashboard");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Left Side */}
      {/* <div className="login-left d-none d-md-flex">
        <div className="overlay">
          <h1 className="text-white fw-bold">Energy Bazzar</h1>
          <p className="text-light mt-2">Your smart energy trading platform</p>
        </div>
      </div> */}

      {/* Right Side */}
      <div className="login-right d-flex align-items-center justify-content-center">
        <div className="login-card m-2 p-4 shadow-lg rounded">
          {/* <h3 className="text-center mb-4">Welcome</h3> */}
          <div className="text-center mb-3">
            <NavLink to='/'>
              <img src={logo} className="w-50" />
            </NavLink>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div className="mb-3">
              <label className="form-label">Email address</label>
              <input
                type="email"
                name="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                placeholder="Enter email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            {/* Password */}
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                name="password"
                className={`form-control ${errors.password ? "is-invalid" : ""}`}
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>

            {/* Submit */}
            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
              {loading ? (
                <div className="spinner-border spinner-border-sm text-light" role="status"></div>
              ) : (
                "Login"
              )}
            </button>
          </form>

          {/* Register */}
          <div className="text-center mt-3">
            <p className="mb-0">
              Don’t have an account?{" "}
              <NavLink to="/register" className="text-decoration-none">
                Sign Up
              </NavLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
